/* eslint-disable */ /* THIS FILE HAS BEEN GENERATED. DO NOT EDIT IT. */ import { jsx as _jsx } from "react/jsx-runtime";
import { createIcon } from '../';
// prettier-ignore
const RefreshIcon = createIcon({
    displayName: 'RefreshIcon',
    viewBox: '0 0 24 25',
    pathSmall: [
        /*#__PURE__*/ _jsx("path", {
            d: "M17.574 13.045c0 1.803-.474 3.194-1.41 4.139-.944.952-2.345 1.434-4.164 1.434-1.94 0-3.402-.547-4.343-1.628-.817-.936-1.23-2.263-1.23-3.945 0-1.588.37-2.863 1.1-3.79.823-1.044 2.117-1.606 3.802-1.73l-.243.253c-.256.264-.519.524-.85.84a9.03 9.03 0 0 1-.346.319l-.263.235.897.987.248-.222c.115-.101.204-.18.388-.356a33.419 33.419 0 0 0 1.846-1.904.906.906 0 0 0 0-1.224 42.33 42.33 0 0 0-.967-1.034 36.083 36.083 0 0 0-.878-.87 10.115 10.115 0 0 0-.39-.356l-.247-.22-.897.986.263.234c.103.09.183.161.347.32.267.255.486.472.697.686-1.922.203-3.452.96-4.454 2.231-.92 1.168-1.387 2.72-1.387 4.615 0 2.013.525 3.635 1.559 4.821C7.84 19.23 9.689 19.952 12 19.952c2.188 0 3.908-.616 5.111-1.83 1.192-1.202 1.796-2.91 1.796-5.077h-1.333Z"
        })
    ],
    pathMedium: [
        /*#__PURE__*/ _jsx("path", {
            d: "M17.979 19.942C16.625 21.308 14.614 22 12 22c-2.788 0-4.885-.785-6.235-2.334C4.594 18.322 4 16.416 4 14c0-2.282.531-4.113 1.58-5.442 1.176-1.493 2.99-2.337 5.398-2.52-.108.114-.215.228-.323.338-.37.38-.748.755-1.224 1.21-.237.229-.352.33-.5.46l-.38.34 1.347 1.48.356-.32c.166-.146.295-.26.561-.516.495-.474.89-.864 1.274-1.26.434-.445.853-.897 1.391-1.486.47-.518.47-1.3-.002-1.818a63.53 63.53 0 0 0-1.395-1.492 50.154 50.154 0 0 0-1.268-1.254c-.267-.257-.396-.37-.563-.517L9.897.886l-1.345 1.48.378.337c.148.131.263.232.502.46.361.348.661.645.95.935-2.746.306-4.934 1.397-6.373 3.222C2.676 9.01 2 11.258 2 14c0 2.913.76 5.261 2.257 6.98C5.98 22.956 8.657 24 12 24c3.167 0 5.656-.892 7.4-2.65C21.124 19.608 22 17.136 22 14h-2c0 2.59-.68 4.589-2.021 5.942Z"
        })
    ]
});
RefreshIcon.defaultProps = {
    fill: 'currentColor',
    boxSize: '24px',
    display: 'block',
    ['data-testid']: 'RefreshIcon'
};
export { RefreshIcon };

//# sourceMappingURL=refresh.js.map